/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AppAccountRouteImport } from './routes/_app.account'
import { Route as AppOrganizationsRouteImport } from './routes/_app.organizations'
import { Route as AppStudioRouteImport } from './routes/_app.studio'
import { Route as AuthErrorRouteImport } from './routes/_auth.error'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthRecoveryRouteImport } from './routes/_auth.recovery'
import { Route as AuthRegistrationRouteImport } from './routes/_auth.registration'
import { Route as AuthVerificationRouteImport } from './routes/_auth.verification'
import { Route as StudioEmbedRouteImport } from './routes/studio_.embed'
import { Route as StudioShareRouteImport } from './routes/studio_.share'
import { Route as AppAccountIndexRouteImport } from './routes/_app.account.index'
import { Route as AppAccountPreferencesRouteImport } from './routes/_app.account.preferences'
import { Route as AppAccountProfileRouteImport } from './routes/_app.account.profile'
import { Route as AppAccountSecurityRouteImport } from './routes/_app.account.security'
import { Route as AppOrganizationsIndexRouteImport } from './routes/_app.organizations.index'
import { Route as AppOrganizationsOrganizationIdRouteImport } from './routes/_app.organizations.$organizationId'
import { Route as AuthOauth2ConsentRouteImport } from './routes/_auth.oauth2.consent'
import { Route as OnboardingOrganizationsNewRouteImport } from './routes/_onboarding.organizations.new'
import { Route as AppOrganizationsOrganizationIdIndexRouteImport } from './routes/_app.organizations.$organizationId.index'
import { Route as AppOrganizationsOrganizationIdAiRouteImport } from './routes/_app.organizations.$organizationId.ai'
import { Route as AppOrganizationsOrganizationIdApiKeysRouteImport } from './routes/_app.organizations.$organizationId.api-keys'
import { Route as AppOrganizationsOrganizationIdBillingRouteImport } from './routes/_app.organizations.$organizationId.billing'
import { Route as AppOrganizationsOrganizationIdMembersRouteImport } from './routes/_app.organizations.$organizationId.members'
import { Route as AppOrganizationsOrganizationIdPreferencesRouteImport } from './routes/_app.organizations.$organizationId.preferences'
import { Route as AppOrganizationsOrganizationIdProfileRouteImport } from './routes/_app.organizations.$organizationId.profile'
import { Route as AppOrganizationsOrganizationIdSecurityRouteImport } from './routes/_app.organizations.$organizationId.security'
import { Route as AppOrganizationsOrganizationIdSettingsRouteImport } from './routes/_app.organizations.$organizationId.settings'
import { Route as AppOrganizationsOrganizationIdSubscriptionRouteImport } from './routes/_app.organizations.$organizationId.subscription'
import { Route as AppOrganizationsOrganizationIdUsageRouteImport } from './routes/_app.organizations.$organizationId.usage'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationsRoute = AppOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppRoute,
} as any)
const AppStudioRoute = AppStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AppRoute,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecoveryRoute = AuthRecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegistrationRoute = AuthRegistrationRouteImport.update({
  id: '/registration',
  path: '/registration',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerificationRoute = AuthVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AuthRoute,
} as any)
const StudioEmbedRoute = StudioEmbedRouteImport.update({
  id: '/studio_/embed',
  path: '/studio/embed',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioShareRoute = StudioShareRouteImport.update({
  id: '/studio_/share',
  path: '/studio/share',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountPreferencesRoute = AppAccountPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountProfileRoute = AppAccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountSecurityRoute = AppAccountSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppOrganizationsIndexRoute = AppOrganizationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizationsRoute,
} as any)
const AppOrganizationsOrganizationIdRoute =
  AppOrganizationsOrganizationIdRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AppOrganizationsRoute,
  } as any)
const AuthOauth2ConsentRoute = AuthOauth2ConsentRouteImport.update({
  id: '/oauth2/consent',
  path: '/oauth2/consent',
  getParentRoute: () => AuthRoute,
} as any)
const OnboardingOrganizationsNewRoute =
  OnboardingOrganizationsNewRouteImport.update({
    id: '/organizations/new',
    path: '/organizations/new',
    getParentRoute: () => OnboardingRoute,
  } as any)
const AppOrganizationsOrganizationIdIndexRoute =
  AppOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdAiRoute =
  AppOrganizationsOrganizationIdAiRouteImport.update({
    id: '/ai',
    path: '/ai',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdApiKeysRoute =
  AppOrganizationsOrganizationIdApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdBillingRoute =
  AppOrganizationsOrganizationIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdMembersRoute =
  AppOrganizationsOrganizationIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdPreferencesRoute =
  AppOrganizationsOrganizationIdPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdProfileRoute =
  AppOrganizationsOrganizationIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdSecurityRoute =
  AppOrganizationsOrganizationIdSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdSettingsRoute =
  AppOrganizationsOrganizationIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdSubscriptionRoute =
  AppOrganizationsOrganizationIdSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)
const AppOrganizationsOrganizationIdUsageRoute =
  AppOrganizationsOrganizationIdUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AppOrganizationsOrganizationIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/account': typeof AppAccountRouteWithChildren
  '/organizations': typeof AppOrganizationsRouteWithChildren
  '/studio': typeof AppStudioRoute
  '/error': typeof AuthErrorRoute
  '/login': typeof AuthLoginRoute
  '/recovery': typeof AuthRecoveryRoute
  '/registration': typeof AuthRegistrationRoute
  '/verification': typeof AuthVerificationRoute
  '/studio/embed': typeof StudioEmbedRoute
  '/studio/share': typeof StudioShareRoute
  '/account/preferences': typeof AppAccountPreferencesRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/organizations/$organizationId': typeof AppOrganizationsOrganizationIdRouteWithChildren
  '/oauth2/consent': typeof AuthOauth2ConsentRoute
  '/organizations/new': typeof OnboardingOrganizationsNewRoute
  '/account/': typeof AppAccountIndexRoute
  '/organizations/': typeof AppOrganizationsIndexRoute
  '/organizations/$organizationId/ai': typeof AppOrganizationsOrganizationIdAiRoute
  '/organizations/$organizationId/api-keys': typeof AppOrganizationsOrganizationIdApiKeysRoute
  '/organizations/$organizationId/billing': typeof AppOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/members': typeof AppOrganizationsOrganizationIdMembersRoute
  '/organizations/$organizationId/preferences': typeof AppOrganizationsOrganizationIdPreferencesRoute
  '/organizations/$organizationId/profile': typeof AppOrganizationsOrganizationIdProfileRoute
  '/organizations/$organizationId/security': typeof AppOrganizationsOrganizationIdSecurityRoute
  '/organizations/$organizationId/settings': typeof AppOrganizationsOrganizationIdSettingsRoute
  '/organizations/$organizationId/subscription': typeof AppOrganizationsOrganizationIdSubscriptionRoute
  '/organizations/$organizationId/usage': typeof AppOrganizationsOrganizationIdUsageRoute
  '/organizations/$organizationId/': typeof AppOrganizationsOrganizationIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/studio': typeof AppStudioRoute
  '/error': typeof AuthErrorRoute
  '/login': typeof AuthLoginRoute
  '/recovery': typeof AuthRecoveryRoute
  '/registration': typeof AuthRegistrationRoute
  '/verification': typeof AuthVerificationRoute
  '/studio/embed': typeof StudioEmbedRoute
  '/studio/share': typeof StudioShareRoute
  '/account/preferences': typeof AppAccountPreferencesRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/oauth2/consent': typeof AuthOauth2ConsentRoute
  '/organizations/new': typeof OnboardingOrganizationsNewRoute
  '/account': typeof AppAccountIndexRoute
  '/organizations': typeof AppOrganizationsIndexRoute
  '/organizations/$organizationId/ai': typeof AppOrganizationsOrganizationIdAiRoute
  '/organizations/$organizationId/api-keys': typeof AppOrganizationsOrganizationIdApiKeysRoute
  '/organizations/$organizationId/billing': typeof AppOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/members': typeof AppOrganizationsOrganizationIdMembersRoute
  '/organizations/$organizationId/preferences': typeof AppOrganizationsOrganizationIdPreferencesRoute
  '/organizations/$organizationId/profile': typeof AppOrganizationsOrganizationIdProfileRoute
  '/organizations/$organizationId/security': typeof AppOrganizationsOrganizationIdSecurityRoute
  '/organizations/$organizationId/settings': typeof AppOrganizationsOrganizationIdSettingsRoute
  '/organizations/$organizationId/subscription': typeof AppOrganizationsOrganizationIdSubscriptionRoute
  '/organizations/$organizationId/usage': typeof AppOrganizationsOrganizationIdUsageRoute
  '/organizations/$organizationId': typeof AppOrganizationsOrganizationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/logout': typeof LogoutRoute
  '/_app/account': typeof AppAccountRouteWithChildren
  '/_app/organizations': typeof AppOrganizationsRouteWithChildren
  '/_app/studio': typeof AppStudioRoute
  '/_auth/error': typeof AuthErrorRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/recovery': typeof AuthRecoveryRoute
  '/_auth/registration': typeof AuthRegistrationRoute
  '/_auth/verification': typeof AuthVerificationRoute
  '/studio_/embed': typeof StudioEmbedRoute
  '/studio_/share': typeof StudioShareRoute
  '/_app/account/preferences': typeof AppAccountPreferencesRoute
  '/_app/account/profile': typeof AppAccountProfileRoute
  '/_app/account/security': typeof AppAccountSecurityRoute
  '/_app/organizations/$organizationId': typeof AppOrganizationsOrganizationIdRouteWithChildren
  '/_auth/oauth2/consent': typeof AuthOauth2ConsentRoute
  '/_onboarding/organizations/new': typeof OnboardingOrganizationsNewRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/organizations/': typeof AppOrganizationsIndexRoute
  '/_app/organizations/$organizationId/ai': typeof AppOrganizationsOrganizationIdAiRoute
  '/_app/organizations/$organizationId/api-keys': typeof AppOrganizationsOrganizationIdApiKeysRoute
  '/_app/organizations/$organizationId/billing': typeof AppOrganizationsOrganizationIdBillingRoute
  '/_app/organizations/$organizationId/members': typeof AppOrganizationsOrganizationIdMembersRoute
  '/_app/organizations/$organizationId/preferences': typeof AppOrganizationsOrganizationIdPreferencesRoute
  '/_app/organizations/$organizationId/profile': typeof AppOrganizationsOrganizationIdProfileRoute
  '/_app/organizations/$organizationId/security': typeof AppOrganizationsOrganizationIdSecurityRoute
  '/_app/organizations/$organizationId/settings': typeof AppOrganizationsOrganizationIdSettingsRoute
  '/_app/organizations/$organizationId/subscription': typeof AppOrganizationsOrganizationIdSubscriptionRoute
  '/_app/organizations/$organizationId/usage': typeof AppOrganizationsOrganizationIdUsageRoute
  '/_app/organizations/$organizationId/': typeof AppOrganizationsOrganizationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/logout'
    | '/account'
    | '/organizations'
    | '/studio'
    | '/error'
    | '/login'
    | '/recovery'
    | '/registration'
    | '/verification'
    | '/studio/embed'
    | '/studio/share'
    | '/account/preferences'
    | '/account/profile'
    | '/account/security'
    | '/organizations/$organizationId'
    | '/oauth2/consent'
    | '/organizations/new'
    | '/account/'
    | '/organizations/'
    | '/organizations/$organizationId/ai'
    | '/organizations/$organizationId/api-keys'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/members'
    | '/organizations/$organizationId/preferences'
    | '/organizations/$organizationId/profile'
    | '/organizations/$organizationId/security'
    | '/organizations/$organizationId/settings'
    | '/organizations/$organizationId/subscription'
    | '/organizations/$organizationId/usage'
    | '/organizations/$organizationId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/logout'
    | '/studio'
    | '/error'
    | '/login'
    | '/recovery'
    | '/registration'
    | '/verification'
    | '/studio/embed'
    | '/studio/share'
    | '/account/preferences'
    | '/account/profile'
    | '/account/security'
    | '/oauth2/consent'
    | '/organizations/new'
    | '/account'
    | '/organizations'
    | '/organizations/$organizationId/ai'
    | '/organizations/$organizationId/api-keys'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/members'
    | '/organizations/$organizationId/preferences'
    | '/organizations/$organizationId/profile'
    | '/organizations/$organizationId/security'
    | '/organizations/$organizationId/settings'
    | '/organizations/$organizationId/subscription'
    | '/organizations/$organizationId/usage'
    | '/organizations/$organizationId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_onboarding'
    | '/logout'
    | '/_app/account'
    | '/_app/organizations'
    | '/_app/studio'
    | '/_auth/error'
    | '/_auth/login'
    | '/_auth/recovery'
    | '/_auth/registration'
    | '/_auth/verification'
    | '/studio_/embed'
    | '/studio_/share'
    | '/_app/account/preferences'
    | '/_app/account/profile'
    | '/_app/account/security'
    | '/_app/organizations/$organizationId'
    | '/_auth/oauth2/consent'
    | '/_onboarding/organizations/new'
    | '/_app/account/'
    | '/_app/organizations/'
    | '/_app/organizations/$organizationId/ai'
    | '/_app/organizations/$organizationId/api-keys'
    | '/_app/organizations/$organizationId/billing'
    | '/_app/organizations/$organizationId/members'
    | '/_app/organizations/$organizationId/preferences'
    | '/_app/organizations/$organizationId/profile'
    | '/_app/organizations/$organizationId/security'
    | '/_app/organizations/$organizationId/settings'
    | '/_app/organizations/$organizationId/subscription'
    | '/_app/organizations/$organizationId/usage'
    | '/_app/organizations/$organizationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  LogoutRoute: typeof LogoutRoute
  StudioEmbedRoute: typeof StudioEmbedRoute
  StudioShareRoute: typeof StudioShareRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizations': {
      id: '/_app/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AppOrganizationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/studio': {
      id: '/_app/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof AppStudioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/error': {
      id: '/_auth/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recovery': {
      id: '/_auth/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof AuthRecoveryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/registration': {
      id: '/_auth/registration'
      path: '/registration'
      fullPath: '/registration'
      preLoaderRoute: typeof AuthRegistrationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verification': {
      id: '/_auth/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof AuthVerificationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/studio_/embed': {
      id: '/studio_/embed'
      path: '/studio/embed'
      fullPath: '/studio/embed'
      preLoaderRoute: typeof StudioEmbedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio_/share': {
      id: '/studio_/share'
      path: '/studio/share'
      fullPath: '/studio/share'
      preLoaderRoute: typeof StudioShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/preferences': {
      id: '/_app/account/preferences'
      path: '/preferences'
      fullPath: '/account/preferences'
      preLoaderRoute: typeof AppAccountPreferencesRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/profile': {
      id: '/_app/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AppAccountProfileRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/security': {
      id: '/_app/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppAccountSecurityRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/organizations/': {
      id: '/_app/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AppOrganizationsIndexRouteImport
      parentRoute: typeof AppOrganizationsRoute
    }
    '/_app/organizations/$organizationId': {
      id: '/_app/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AppOrganizationsRoute
    }
    '/_auth/oauth2/consent': {
      id: '/_auth/oauth2/consent'
      path: '/oauth2/consent'
      fullPath: '/oauth2/consent'
      preLoaderRoute: typeof AuthOauth2ConsentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_onboarding/organizations/new': {
      id: '/_onboarding/organizations/new'
      path: '/organizations/new'
      fullPath: '/organizations/new'
      preLoaderRoute: typeof OnboardingOrganizationsNewRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_app/organizations/$organizationId/': {
      id: '/_app/organizations/$organizationId/'
      path: '/'
      fullPath: '/organizations/$organizationId/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/ai': {
      id: '/_app/organizations/$organizationId/ai'
      path: '/ai'
      fullPath: '/organizations/$organizationId/ai'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdAiRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/api-keys': {
      id: '/_app/organizations/$organizationId/api-keys'
      path: '/api-keys'
      fullPath: '/organizations/$organizationId/api-keys'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdApiKeysRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/billing': {
      id: '/_app/organizations/$organizationId/billing'
      path: '/billing'
      fullPath: '/organizations/$organizationId/billing'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBillingRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/members': {
      id: '/_app/organizations/$organizationId/members'
      path: '/members'
      fullPath: '/organizations/$organizationId/members'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdMembersRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/preferences': {
      id: '/_app/organizations/$organizationId/preferences'
      path: '/preferences'
      fullPath: '/organizations/$organizationId/preferences'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdPreferencesRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/profile': {
      id: '/_app/organizations/$organizationId/profile'
      path: '/profile'
      fullPath: '/organizations/$organizationId/profile'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdProfileRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/security': {
      id: '/_app/organizations/$organizationId/security'
      path: '/security'
      fullPath: '/organizations/$organizationId/security'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSecurityRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/settings': {
      id: '/_app/organizations/$organizationId/settings'
      path: '/settings'
      fullPath: '/organizations/$organizationId/settings'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSettingsRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/subscription': {
      id: '/_app/organizations/$organizationId/subscription'
      path: '/subscription'
      fullPath: '/organizations/$organizationId/subscription'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSubscriptionRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
    '/_app/organizations/$organizationId/usage': {
      id: '/_app/organizations/$organizationId/usage'
      path: '/usage'
      fullPath: '/organizations/$organizationId/usage'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdUsageRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRoute
    }
  }
}

interface AppAccountRouteChildren {
  AppAccountPreferencesRoute: typeof AppAccountPreferencesRoute
  AppAccountProfileRoute: typeof AppAccountProfileRoute
  AppAccountSecurityRoute: typeof AppAccountSecurityRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountPreferencesRoute: AppAccountPreferencesRoute,
  AppAccountProfileRoute: AppAccountProfileRoute,
  AppAccountSecurityRoute: AppAccountSecurityRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppOrganizationsOrganizationIdRouteChildren {
  AppOrganizationsOrganizationIdAiRoute: typeof AppOrganizationsOrganizationIdAiRoute
  AppOrganizationsOrganizationIdApiKeysRoute: typeof AppOrganizationsOrganizationIdApiKeysRoute
  AppOrganizationsOrganizationIdBillingRoute: typeof AppOrganizationsOrganizationIdBillingRoute
  AppOrganizationsOrganizationIdMembersRoute: typeof AppOrganizationsOrganizationIdMembersRoute
  AppOrganizationsOrganizationIdPreferencesRoute: typeof AppOrganizationsOrganizationIdPreferencesRoute
  AppOrganizationsOrganizationIdProfileRoute: typeof AppOrganizationsOrganizationIdProfileRoute
  AppOrganizationsOrganizationIdSecurityRoute: typeof AppOrganizationsOrganizationIdSecurityRoute
  AppOrganizationsOrganizationIdSettingsRoute: typeof AppOrganizationsOrganizationIdSettingsRoute
  AppOrganizationsOrganizationIdSubscriptionRoute: typeof AppOrganizationsOrganizationIdSubscriptionRoute
  AppOrganizationsOrganizationIdUsageRoute: typeof AppOrganizationsOrganizationIdUsageRoute
  AppOrganizationsOrganizationIdIndexRoute: typeof AppOrganizationsOrganizationIdIndexRoute
}

const AppOrganizationsOrganizationIdRouteChildren: AppOrganizationsOrganizationIdRouteChildren =
  {
    AppOrganizationsOrganizationIdAiRoute:
      AppOrganizationsOrganizationIdAiRoute,
    AppOrganizationsOrganizationIdApiKeysRoute:
      AppOrganizationsOrganizationIdApiKeysRoute,
    AppOrganizationsOrganizationIdBillingRoute:
      AppOrganizationsOrganizationIdBillingRoute,
    AppOrganizationsOrganizationIdMembersRoute:
      AppOrganizationsOrganizationIdMembersRoute,
    AppOrganizationsOrganizationIdPreferencesRoute:
      AppOrganizationsOrganizationIdPreferencesRoute,
    AppOrganizationsOrganizationIdProfileRoute:
      AppOrganizationsOrganizationIdProfileRoute,
    AppOrganizationsOrganizationIdSecurityRoute:
      AppOrganizationsOrganizationIdSecurityRoute,
    AppOrganizationsOrganizationIdSettingsRoute:
      AppOrganizationsOrganizationIdSettingsRoute,
    AppOrganizationsOrganizationIdSubscriptionRoute:
      AppOrganizationsOrganizationIdSubscriptionRoute,
    AppOrganizationsOrganizationIdUsageRoute:
      AppOrganizationsOrganizationIdUsageRoute,
    AppOrganizationsOrganizationIdIndexRoute:
      AppOrganizationsOrganizationIdIndexRoute,
  }

const AppOrganizationsOrganizationIdRouteWithChildren =
  AppOrganizationsOrganizationIdRoute._addFileChildren(
    AppOrganizationsOrganizationIdRouteChildren,
  )

interface AppOrganizationsRouteChildren {
  AppOrganizationsOrganizationIdRoute: typeof AppOrganizationsOrganizationIdRouteWithChildren
  AppOrganizationsIndexRoute: typeof AppOrganizationsIndexRoute
}

const AppOrganizationsRouteChildren: AppOrganizationsRouteChildren = {
  AppOrganizationsOrganizationIdRoute:
    AppOrganizationsOrganizationIdRouteWithChildren,
  AppOrganizationsIndexRoute: AppOrganizationsIndexRoute,
}

const AppOrganizationsRouteWithChildren =
  AppOrganizationsRoute._addFileChildren(AppOrganizationsRouteChildren)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppOrganizationsRoute: typeof AppOrganizationsRouteWithChildren
  AppStudioRoute: typeof AppStudioRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppOrganizationsRoute: AppOrganizationsRouteWithChildren,
  AppStudioRoute: AppStudioRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthErrorRoute: typeof AuthErrorRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRecoveryRoute: typeof AuthRecoveryRoute
  AuthRegistrationRoute: typeof AuthRegistrationRoute
  AuthVerificationRoute: typeof AuthVerificationRoute
  AuthOauth2ConsentRoute: typeof AuthOauth2ConsentRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthErrorRoute: AuthErrorRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRecoveryRoute: AuthRecoveryRoute,
  AuthRegistrationRoute: AuthRegistrationRoute,
  AuthVerificationRoute: AuthVerificationRoute,
  AuthOauth2ConsentRoute: AuthOauth2ConsentRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface OnboardingRouteChildren {
  OnboardingOrganizationsNewRoute: typeof OnboardingOrganizationsNewRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingOrganizationsNewRoute: OnboardingOrganizationsNewRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  LogoutRoute: LogoutRoute,
  StudioEmbedRoute: StudioEmbedRoute,
  StudioShareRoute: StudioShareRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
